import { ObserveRefreshData, Vehicle } from "../../../../../types/observe";
import { videoMixPat } from "../../../../../utils/sendData";

import "./VideoSwitch.scss";
import videoImgA from "../../../../../assets/imgs/observe/videoswch_a01.svg";
import videoImgB from "../../../../../assets/imgs/observe/videoswch_b01.svg";
import videoImgC from "../../../../../assets/imgs/observe/videoswch_c01.svg";
import videoImgD from "../../../../../assets/imgs/observe/videoswch_d01.svg";

interface VideoSwitchProps {
  refreshData: ObserveRefreshData | null;
  observeCC: string | null;
  vehicle: Vehicle | null;
  sendData: (msg: object) => void;
}

const VideoSwitch = ({
  refreshData,
  observeCC,
  vehicle,
  sendData,
}: VideoSwitchProps) => {
  const selected = refreshData?.info?.movie_switching;
  const isSelecting = refreshData?.info?.is_selecting;
  const sr = observeCC;
  const dt = vehicle?.vehicle_communication_code;

  const isActive = (value: string) =>
    selected === value && isSelecting === "1" ? "active" : "";

  const handleClick = (value: number) => {
    if (!sr || !dt) return;

    sendData(videoMixPat(sr, dt, value));
  };

  return (
    <div className="videoSwitchArea">
      <div className="title">監視/運転映像切替</div>
      <div className="buttonWrapper">
        <button
          className={isActive("1")}
          disabled={isSelecting !== "1"}
          onClick={() => handleClick(1)}
        >
          <img src={videoImgA} alt="A" />
        </button>
        <button
          className={isActive("2")}
          disabled={isSelecting !== "1"}
          onClick={() => handleClick(2)}
        >
          <img src={videoImgB} alt="B" />
        </button>
        <button
          className={isActive("3")}
          disabled={isSelecting !== "1"}
          onClick={() => handleClick(3)}
        >
          <img src={videoImgC} alt="C" />
        </button>
        <button
          className={isActive("4")}
          disabled={isSelecting !== "1"}
          onClick={() => handleClick(4)}
        >
          <img src={videoImgD} alt="D" />
        </button>
      </div>
    </div>
  );
};

export default VideoSwitch;
